import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useWebAuth } from '../../../hooks/useWebAuth';
import { getAdminUserDetail } from '../../../api/admin-api';
import { StatCard } from '../components/StatCard';
import './UserDetailPage.scss';

export function UserDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { token } = useWebAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token || !id) return;
    getAdminUserDetail(token, id)
      .then(setUser)
      .finally(() => setLoading(false));
  }, [token, id]);

  if (loading) return <div className="user-detail">Loading...</div>;
  if (!user) return <div className="user-detail">User not found</div>;

  return (
    <div className="user-detail">
      <button className="user-detail__back" onClick={() => navigate('/admin/users')}>
        &larr; Back to Users
      </button>

      <h1 className="user-detail__title">{user.email ?? 'Anonymous User'}</h1>

      <section className="user-detail__section">
        <h2 className="user-detail__section-title">Profile</h2>
        <div className="user-detail__grid">
          <StatCard label="Auth Provider" value={user.authProvider} />
          <StatCard label="Status" value={user.status} />
          <StatCard label="Created" value={new Date(user.createdAt).toLocaleDateString()} />
          <StatCard label="Last Active" value={user.lastActiveAt ? new Date(user.lastActiveAt).toLocaleDateString() : '-'} />
        </div>
      </section>

      <section className="user-detail__section">
        <h2 className="user-detail__section-title">Subscription</h2>
        <div className="user-detail__grid">
          <StatCard label="Plan" value={user.plan} />
          <StatCard label="Status" value={user.subscriptionStatus ?? '-'} />
          <StatCard label="Paddle ID" value={user.paddleSubscriptionId ?? '-'} />
          <StatCard label="Renewal" value={user.currentPeriodEnd ? new Date(user.currentPeriodEnd).toLocaleDateString() : '-'} />
        </div>
      </section>

      <section className="user-detail__section">
        <h2 className="user-detail__section-title">Usage</h2>
        <div className="user-detail__grid">
          <StatCard label="Total Shares" value={user.sharesCount} />
        </div>
      </section>

      {user.recentShares?.length > 0 && (
        <section className="user-detail__section">
          <h2 className="user-detail__section-title">Recent Shares</h2>
          <table className="user-detail__table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Detail</th>
                <th>Created</th>
                <th>Views</th>
              </tr>
            </thead>
            <tbody>
              {user.recentShares.map((share: any) => (
                <tr key={share.shareId}>
                  <td>{share.type}</td>
                  <td>{share.type === 'single' ? `${share.method} ${share.url}` : `${share.entryCount} requests`}</td>
                  <td>{new Date(share.createdAt).toLocaleDateString()}</td>
                  <td>{share.viewCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}
    </div>
  );
}
